// removed by extract-text-webpack-plugin
module.exports = {"box":"_1jJ6sge4NCOLAE-R1tO3S6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/BoxShadow/style.css
// module id = 247
// module chunks = 42